import SearchLogsForm from './SearchLogsForm';

export default SearchLogsForm;


// WEBPACK FOOTER //
// ./src/features/log/components/search-logs-form/index.js